import { initialPrice } from "@shared-logic/prices";
import { Commission, Order, Quotas } from "./order.interface";
import { PLACE_OF_ORIGIN_VOID } from "@shared-logic/locations";
import { BUYER_COMMISION, SELLER_COMMISION, SELLER_DATA_VOID } from "@shared-logic/subjects";


export const OBJECT_ID_VOID = "000000000000000000000000";

export const orderOriginConst = {
    desdeTablero: 1,
    manual: 2,
    desdeTableroModificada: 3,
};

export const orderCategoryConst = {
    orderSale: 1,
    orderPurchase: 2,
};

export const orderTypeConst = {
    orderPrice: 1,
    orderToSet: 2,
};

export const orderStatusConst = {
    RETURNED: 1,
    PENDING: 2,
    CONFIRM: 3,
    CHECK: 4,
    OFERTED: 5,
    SEND_TO_BROKE: 6,
    AUTORIZATION: 7,
    CONTRACT: 8,
    OUT_OF_MARKET: 9,
};

export const QUOTA_VOID: Quotas = { date: '--', trucks: -1 };

export const COMMISION_VOID: Commission = {
    buyer: BUYER_COMMISION,
    seller: SELLER_COMMISION,
};

export const orderInitialState: Order = {
    _id: 0,
    price: initialPrice,
    contractNumber: -1,
    placeOfOrigin: PLACE_OF_ORIGIN_VOID,
    broke: 1, //Broker: Grassi
    howSell: -1,
    purchaseMethod: 0,
    buyer: {
        onlySell: [],
        notSell: [],
    },
    arrayMods: [],
    tons: -1,
    statusOrder: orderStatusConst.PENDING,
    quotas: JSON.stringify([QUOTA_VOID]),
    commision: COMMISION_VOID,
    dataOfcreation: {
        nameOfcreator: '--',
        email: '--',
        teamOfcreator: {
            nroTeam: -1,
            bossName: '--',
            bossLastName: '--',
        },
        dateOfcreation: '--',
        hour: '--',
    },
    orderDestination: {
        orderOrigin: -1, //Desde el tablero o manual // orderOriginConst
        orderCategory: orderCategoryConst.orderSale, //De venta o de compra //orderCategoryConst
        orderType: orderTypeConst.orderPrice, //A precio o A fijar // orderTypeConst
    },
    sellerData: SELLER_DATA_VOID,
    obsParam: '--',
    idExchange: '',
    message: '',
    created_at: '',
};


export const orderTags = {
    price: 'price',
    name: 'name',
    placeOfOrigin: 'placeOfOrigin',
    town: 'town',
    province: 'province',
    afip: 'afip',
    broke: 'broke',
    howSell: 'howSell',
    buyer: 'buyer',
    onlySell: 'onlySell',
    notSell: 'notSell',
    tons: 'tons',
    statusOrder: 'statusOrder',
    quotas: 'quotas',
    orderDestination: 'orderDestination',
    orderOrigin: 'orderOrigin',
    orderType: 'orderType',
    orderCategory: 'orderCategory',
    commision: 'commision',
    comissionSeller: 'seller',
    comissionBuyer: 'buyer',
    message: 'message',
    nameOfcreator: 'nameOfcreator',
    dateOfcreation: 'dateOfcreation',
    dataOfCreation: 'dataOfcreation',
    sellerName: 'sellerName',
    sellerData: 'sellerData',
    observationsParameterized: 'obsParam',
    codeS: 'codeS',
    sucG: 'sucG',
    cuit: 'cuit',
    hour: 'hour',
};
